import React, { useState } from 'react';
import './DemoMeetingPopup.css';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import axios from 'axios';

const DemoMeetingPopup = ({ isOpen, onClose }) => {
  const [selectedDate, setSelectedDate] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    company: '',
    description: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async () => {
    try {
      const payload = {
        ...formData,
        meetingDateTime: selectedDate,
      };
      console.log(payload);
      await axios.post('https://prod-36.northeurope.logic.azure.com:443/workflows/6e964616a71d4595a40261da38535346/triggers/manual/paths/invoke?api-version=2016-06-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=IljrfGtLoRNFBOEkgbPD4Gu7hA3BtA7p90Pvg0IFivw', payload);
      alert('הבקשה נשלחה בהצלחה!');
      onClose();
    } catch (error) {
      alert('שגיאה בשליחת הבקשה');
      console.error(error);
    }
  };

  const isWeekday = (date) => {
    const day = date.getDay();
    return day >= 0 && day <= 4; // Sunday to Thursday
  };

  const filterTime = (time) => {
    const hour = time.getHours();
    return hour >= 9 && hour <= 18;
  };

  if (!isOpen) return null;

  return (
    <div className="demo-popup-overlay">
      <div className="demo-popup">
        <button className="demo-popup-close" onClick={onClose}>×</button>
        <div className="demo-popup-content">
          <div className="demo-popup-calendar">
            <h3>בחר תאריך ושעה</h3>
            <DatePicker
              selected={selectedDate}
              onChange={(date) => setSelectedDate(date)}
              showTimeSelect
              filterDate={isWeekday}
              filterTime={filterTime}
              dateFormat="dd/MM/yyyy HH:mm"
              placeholderText="בחר תאריך ושעה"
              timeFormat="HH:mm"
              timeIntervals={30}
              className="datepicker"
            />
          </div>
          <div className="demo-popup-form">
            <h3>פרטי החברה</h3>
            <input type="text" name="name" placeholder="שם" value={formData.name} onChange={handleChange} />
            <input type="text" name="phone" placeholder="טלפון" value={formData.phone} onChange={handleChange} />
            <input type="email" name="email" placeholder="אימייל" value={formData.email} onChange={handleChange} />
            <input type="text" name="company" placeholder="שם החברה" value={formData.company} onChange={handleChange} />
            <textarea name="description" placeholder="תיאור" value={formData.description} onChange={handleChange}></textarea>
            <button className="demo-popup-form-submit-btn" onClick={handleSubmit}>שלח בקשה</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DemoMeetingPopup;
